import {Component, OnInit, Input} from '@angular/core';
import {TimelineData} from './timeline.types';
import {TimeSeriesValue} from 'src/app/charts/line-chart/line-chart.component';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent implements OnInit {

  @Input() data: TimelineData[] = [];
  mockTimeseriesData: TimeSeriesValue<number>[];
  filterIsExpanded: boolean = false;
  filters = [];

  constructor() {}

  ngOnInit() {

    this.mockTimeseriesData = [
      new TimeSeriesValue(new Date(2018, 11, 1), 3000),
      new TimeSeriesValue(new Date(2019, 0, 1), 4000),
      new TimeSeriesValue(new Date(2019, 1, 1), 5000),
      new TimeSeriesValue(new Date(2019, 2, 1), 5000),
      new TimeSeriesValue(new Date(2019, 3, 1), 4000),
      new TimeSeriesValue(new Date(2019, 4, 1), 5000),
      new TimeSeriesValue(new Date(2019, 5, 1), 6000),
      new TimeSeriesValue(new Date(2019, 6, 1), 7000),
      new TimeSeriesValue(new Date(2019, 7, 1), 6000),
      new TimeSeriesValue(new Date(2019, 8, 1), 7000),
      new TimeSeriesValue(new Date(2019, 9, 1), 8000),
      new TimeSeriesValue(new Date(2019, 10, 1), 7000),
      new TimeSeriesValue(new Date(2019, 11, 1), 6000),
      new TimeSeriesValue(new Date(2020, 0, 1), 5000)
    ];

    this.filters = [
      {
        'group': 'Activity Type',
        'filters': [
          {'id': 1, 'description': 'User generated', selected: true},
          {'id': 2, 'description': 'System generated', selected: false},
        ]
      },
      {
        'group': 'Period',
        'filters': [
          {'id': 1, 'description': 'Today', selected: false},
          {'id': 2, 'description': 'Yesterday', selected: false},
          {'id': 3, 'description': 'This week', selected: true},
          {'id': 3, 'description': 'This month', selected: false},
        ]
      },
      {
        'group': 'Reinsurer',
        'filters': [
          {'id': 1, 'description': 'Reinsurer 1', selected: false},
          {'id': 2, 'description': 'Reinsurer 2', selected: false},
          {'id': 3, 'description': 'Reinsurer 3', selected: false},
          {'id': 3, 'description': 'Reinsurer 4', selected: false},
        ]
      }
    ];

  }

  toggleFilters() {
    this.filterIsExpanded = !this.filterIsExpanded;
  }

}
